import 'angular';

import { AdminReportsCtrl } from './admin-reports.ajs';
import { ReportsCtrl }      from './reports';
import { ReportsStates }    from './reports.states.ajs';

angular.module('workshop.reports', [])
.config(ReportsStates)
.controller('AdminReportsCtrl', AdminReportsCtrl)
.controller('baseReport', ReportsCtrl);